import { TenantService } from '@libs/services/tenant.service';
import { Component } from '@angular/core';
import { AuthService } from '@libs/services/firebase/auth.service';
import { UserRole } from './models/user.model';
import { UserService } from './services/user.service';
import { Router } from '@angular/router';
import { TenantThemeService } from '@libs/services/tenant-theme.service';
import { TenantStatus } from '@libs/models/tenant.models';
import {
  getStudentHostname,
  getTenantDomain,
  isCoreStudentDomain,
} from './constants/domain.const';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private authService: AuthService,
    private userService: UserService,
    private tenantService: TenantService,
    private router: Router,
    private tenantThemeService: TenantThemeService
  ) {
    this.setupUser();
  }

  async setupUser() {
    const hostname = getStudentHostname();

    if (!isCoreStudentDomain(hostname)) {
      const tenant = (await this.tenantService.load({
        where: [
          {
            key: 'subdomain', condition: '==', value: getTenantDomain(hostname)
          }
        ]
      }))[0];

      if (!tenant) {
        this.router.navigate(["404"]);
        return;
      }

      if (tenant.status === TenantStatus.INACTIVE) {
        this.router.navigate(['404'], {
          queryParams: { reason: 'tenant-inactive' }
        });
        return;
      }

      this.tenantService.currentTenant.next(tenant);
      this.tenantThemeService.applyTheme(tenant.whitelabel);
    }

    this.authService.authStateChange(UserRole.STUDENT);
    this.userService.setupUser();
  }
}
